// extracted by mini-css-extract-plugin
module.exports = {"container":"AwardsMain_container__QGmal","tablet":"AwardsMain_tablet__2i21J","slider_item":"AwardsMain_slider_item__2QXZD","mobile":"AwardsMain_mobile__3kHsy"};